import React from "react";
import Book from "../../components/Book/Book";
import classes from "./ServicesPage.css";

const services = (props) => {
    const servicePrices = [
        { service: "Long Hair (Scissors Only)", price: 45 },
        { service: "Zero Fade", price: 45 },
        { service: "Haircut", price: 40 },
        { service: "Buzz Cut", price: 25 },
        { service: "Beard Trim", price: 25 },
        { service: "Haircut & Beard", price: 55 },
        { service: "Seniors", price: 38 },
        { service: "Students", price: 35 },
        { service: "Kids", price: 30 },
        { service: "Hot Towel Cut-Throat Face Shave", price: 60 },
    ];

    return (
        <div className={classes.ServicesPage}>
            <div className={classes.title}>
                <span>SERVICES</span>
            </div>
            <div className={classes.window}>
                {servicePrices.map(({ service, price }) => {
                    return (
                        <p>
                            {service}
                            <span style={{ float: "right" }}>${price}</span>
                        </p>
                    );
                })}

                <p className={classes.footnote}>
                    Colours & Highlights available, including grey hair cover!
                </p>
            </div>
            <Book />
        </div>
    );
};

export default services;



// WEBPACK FOOTER //
// ./src/containers/ServicesPage/ServicesPage.js